// extracted by mini-css-extract-plugin
module.exports = {"toc__data":"x_fk","toc__link":"x_fl"};